import { NavLink } from 'react-router-dom'
import { Inbox, LayoutList, Plus, Icon } from "lucide-react"
import { cn } from '@/lib/utils'
import { useI18n } from '@/i18n'

const tabs = [
  { to: '/studio', end: true, key: 'studio.overview', icon: Inbox },
  { to: '/studio/listings', end: false, key: 'studio.listings', icon: LayoutList },
  { to: '/studio/new', end: false, key: 'studio.newListing', icon: Plus },
]

/**
 * Studio tabs. Scrolls sideways on a phone rather than wrapping — a two-line
 * tab bar makes a small screen feel like a filing cabinet.
 */
export function StudioNav() {
  const { t } = useI18n()

  return (
    <nav
      aria-label="Studio"
      data-upbo-id="studio-nav"
      data-upbo-label="Studio navigation"
      className="flex items-center gap-1 overflow-x-auto no-scrollbar border-b border-border"
    >
      {tabs.map(({ to, end, key, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              'inline-flex items-center gap-2 px-4 py-3.5 text-[11px] font-medium uppercase tracking-[0.14em] whitespace-nowrap',
              'border-b-2 -mb-px transition-colors',
              isActive
                ? 'border-text text-text'
                : 'border-transparent text-text-muted hover:text-text',
            )
          }
        >
          <Icon size={15} strokeWidth={1.5} />
          {t(key)}
        </NavLink>
      ))}
    </nav>
  )
}
